import axios from 'axios'

export const $authUser = axios.create({
    headers: {
        Authorization: 'Bearer'
    },
    baseURL: process.env.VUE_APP_ALERUS_API_URL
})

export const $secureNowUser = axios.create({
    headers: {
        Authorization: 'Bearer'
    },
    // baseURL: 'https://api.alerus.com'
})

export const $unAuthUser = axios.create({
    baseURL: process.env.VUE_APP_APPSYNC_API_URL
})
